import * as React from 'react';
import { useSelector } from 'react-redux';
import { useContext } from 'react';

import { NewReviewModalRating } from '../../../components/NewReviewModal';
import { getNewReviewFlow } from '../../../selectors/newReview/getNewReviewFlow';
import { ENewReviewFlow } from '../../../types/newReview';
import { DailyrentNewReviewModalFooterContainer } from '../../DailyrentNewReviewModalFooter';
import { FormModalLayout } from '../../../components/FormLayout';
import { NewReviewContext } from '../../../utils/newReview/context';
import { StarsSelect } from './StarsSelect';
import { useRatingsContainer } from './hooks/useRatingsContainer';
import { selectIsCurrentStepValid } from '../../../selectors/newReview';
import { ErrorSnackbar } from '../../../components/DailyrentNewReview/ErrorSnackbar';
import { trackShow } from './tracking';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getObjectId } from '../../../selectors/objectInfo';
import { TripInfoBannerContainer } from '../TripInfoBannerContainer';

export function RatingsContainer() {
  const { custom } = useApplicationContext();
  const objectId = useSelector(getObjectId);
  const { isOpened, onClose } = useContext(NewReviewContext);
  const flow = useSelector(getNewReviewFlow);
  const {
    overallScore,
    polite,
    priceAndQuality,
    location,
    comfortAndAppliance,
    cleaning,

    setOverallScore,
    setPoliteScore,
    setPriceAndQualityScore,
    setLocationScore,
    setComfortAndApplianceScore,
    setCleaningScore,
  } = useRatingsContainer();
  const isCurrentStepValid = useSelector(selectIsCurrentStepValid);
  const [isSnackbarOpen, setIsSnackbarOpen] = React.useState<boolean>(false);

  const handleNextClick = React.useCallback(() => {
    if (!isCurrentStepValid) {
      setIsSnackbarOpen(true);
    }
  }, [isCurrentStepValid]);

  React.useEffect(() => {
    if (isCurrentStepValid) {
      setIsSnackbarOpen(false);
    }
  }, [isCurrentStepValid]);

  React.useEffect(() => {
    if (isOpened) {
      trackShow(objectId, custom.deviceType);
    }
  }, [isOpened]);

  return (
    <FormModalLayout
      title="Новый отзыв"
      shortTitle="Новый отзыв"
      footer={<DailyrentNewReviewModalFooterContainer onNextClick={handleNextClick} />}
      onClose={onClose}
      type="form"
      open={isOpened}
      testId="NewReview"
    >
      <NewReviewModalRating>
        <TripInfoBannerContainer />
        <StarsSelect title="Общая оценка" value={overallScore} required onChange={setOverallScore} />
        <StarsSelect title="Вежливость" value={polite} onChange={setPoliteScore} />
        {flow === ENewReviewFlow.Success && (
          <>
            <StarsSelect title="Цена/Качество" value={priceAndQuality} onChange={setPriceAndQualityScore} />
            <StarsSelect title="Расположение" value={location} onChange={setLocationScore} />
            <StarsSelect title="Комфорт и техника" value={comfortAndAppliance} onChange={setComfortAndApplianceScore} />
            <StarsSelect title="Чистота" value={cleaning} onChange={setCleaningScore} />
          </>
        )}
        <ErrorSnackbar isOpen={isSnackbarOpen} message="Поставьте общую оценку" />
      </NewReviewModalRating>
    </FormModalLayout>
  );
}
